// Get voice name from ID
export function getVoiceName(voiceId) {
    // Default system voices
    const systemVoices = [
        { id: 'Wise_Woman', name: '智慧女性' },
        { id: 'Friendly_Person', name: '友善人士' },
        { id: 'Inspirational_girl', name: '鼓舞女孩' },
        { id: 'Deep_Voice_Man', name: '深沉男聲' },
        { id: 'Calm_Woman', name: '冷靜女性' },
        { id: 'Casual_Guy', name: '隨性男生' },
        { id: 'Lively_Girl', name: '活潑女孩' },
        { id: 'Patient_Man', name: '耐心男性' },
        { id: 'Young_Knight', name: '年輕騎士' },
        { id: 'Determined_Man', name: '堅定男性' },
        { id: 'Lovely_Girl', name: '可愛女孩' },
        { id: 'Decent_Boy', name: '端莊男孩' },
        { id: 'Imposing_Manner', name: '威嚴風格' },
        { id: 'Elegant_Man', name: '優雅男性' },
        { id: 'Abbess', name: '修女' },
        { id: 'Sweet_Girl_2', name: '甜美女孩2' },
        { id: 'Exuberant_Girl', name: '活力女孩' },
        { id: 'English_expressive_narrator', name: '表達力豐富的敘述者 (英語)' },
        { id: 'English_compelling_lady', name: '引人入勝的女士 (英語)' }
    ];
    
    const voice = systemVoices.find(v => v.id === voiceId);
    return voice ? voice.name : voiceId;
}

// Format language name
export function formatLanguage(languageCode) {
    const languageMap = {
        'Chinese,Yue': '廣東話',
        'Chinese': '中文 (普通話)',
        'English': '英文',
        'Japanese': '日文',
        'Korean': '韓文',
        'French': '法文',
        'German': '德文',
        'Spanish': '西班牙文',
        'Portuguese': '葡萄牙文',
        'Italian': '義大利文',
        'Russian': '俄文',
        'Arabic': '阿拉伯文',
        'Turkish': '土耳其文',
        'Dutch': '荷蘭文',
        'Ukrainian': '烏克蘭文',
        'Vietnamese': '越南文',
        'Indonesian': '印尼文',
        'auto': '自動偵測'
    };
    
    return languageMap[languageCode] || languageCode;
}

// Format emotion name
export function formatEmotion(emotion) {
    const emotionMap = {
        'happy': '開心',
        'sad': '悲傷',
        'angry': '憤怒',
        'fearful': '恐懼',
        'disgusted': '厭惡',
        'surprised': '驚訝',
        'neutral': '中性'
    };
    
    return emotionMap[emotion] || emotion;
}

// Function to fetch audio as binary data
export async function fetchAudioAsBinary(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Failed to fetch audio file');
        }
        
        // Get the audio file as ArrayBuffer (binary data)
        const arrayBuffer = await response.arrayBuffer();
        return arrayBuffer;
    } catch (error) {
        console.error('Error fetching audio as binary:', error);
        throw error;
    }
}

export const formatDuration = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // 根據小時數決定格式
    if (hours > 0) {
        return `${hours}h ${minutes}min ${seconds}s`;
    } else if (minutes > 0) {
        return `${minutes}min ${seconds}s`;
    } else {
        return `${seconds}s`;
    }
};
